import React from 'react';
import { Box } from '@mui/material';
import Pagination from '../../../../../dsasComponents/pagination/Pagination.js';
import PlayerCard from './PlayerCard';
import { faPlus, faUserPlus } from '@fortawesome/free-solid-svg-icons';
import DsasButton from '../../../../components/DsasButton/DsasButton.js';
import useStyles from '../../../../../styles/global-mui.js';
import { Can } from '../../../../../permissions/Can.js';
import { PERMISSIONS } from '../../../../../permissions/permissionKeys.js';

const PlayerResults = ({
  showCreate,
  handleSelectOtherPlayer,
  players,
  onExportCSV,
  canExport = false,
  actions = [],
  removePlayerFromList,
  exportResult = true,
  showExport = true,
  showPicture = true,
  searchMode,
  fieldsValidator,
}) => {
  const classes = useStyles();

  const mandatorySearchInfo =
    searchMode === 'simple' ? 'Nom, Discipline' : 'Discipline, Compétition, Équipe';

  const isSearchValid =
    typeof fieldsValidator === 'function' ? fieldsValidator() : false;

  const showExportButton = exportResult && canExport;

  // 1) Cas: recherche invalide
  // -> On affiche le message pour la recherche
  // -> MAIS si on peut exporter (jusqu'à compétition), on affiche quand même le bouton export
  if (!isSearchValid) {
    return (
      <>
        <Box className="left-medium-wrapper">
          {`Veuillez saisir les filtres obligatoires (${mandatorySearchInfo}).`}
        </Box>

        {showExportButton && (
          <>
            <Box className="medium-separator" />
            <Box className="left-medium-wrapper">
              <Can permission={PERMISSIONS.SPORT_PLAYER_HOME_BUTTON_EXPORTCSV}>
                <DsasButton
                  label="Exporter les joueurs en CSV"
                  icon={faUserPlus}
                  onClick={onExportCSV}
                  variant="secondary"
                />
              </Can>
            </Box>
          </>
        )}
      </>
    );
  }

  // 2) Cas: recherche valide et résultats
  if (players && players.length > 0) {
    return (
      <>
        {showExportButton && (
          <Box className="left-medium-wrapper">
            <Can permission={PERMISSIONS.SPORT_PLAYER_HOME_BUTTON_EXPORTCSV}>
              <DsasButton
                label="Exporter les joueurs en CSV"
                icon={faUserPlus}
                onClick={onExportCSV}
                variant="secondary"
              />
            </Can>
          </Box>
        )}

        <Box className="large-separator medium-padding"></Box>

        <Box className="padding-wrapper">
          <Pagination
            items={players}
            type="Joueurs"
            className={classes.customTablePagination}
          >
            {players.map((player) => (
              <PlayerCard
                key={player._id || player.id}
                player={player}
                actions={actions}
                removePlayerFromList={removePlayerFromList}
                className={classes.customCard}
                showExport={showExport}
                showPicture={showPicture}
              />
            ))}
          </Pagination>
        </Box>
      </>
    );
  }

  // 3) Cas: recherche valide mais aucun résultat
  return (
    <>
      {showExportButton && (
        <Box className="left-medium-wrapper">
          <Can permission={PERMISSIONS.SPORT_PLAYER_HOME_BUTTON_EXPORTCSV}>
            <DsasButton
              label="Exporter les joueurs en CSV"
              icon={faUserPlus}
              onClick={onExportCSV}
              variant="secondary"
            />
          </Can>
        </Box>
      )}

      <Box className="left-medium-wrapper">Aucun joueur trouvé.</Box>

      {showCreate && (
        <Box className="centered-medium-wrapper">
          <Can permission={PERMISSIONS.SPORT_PLAYER_HOME_BUTTON_CREATE}>
            <DsasButton
              label="Créer avec les données saisies"
              icon={faPlus}
              onClick={handleSelectOtherPlayer}
              variant="secondary"
            />
          </Can>
        </Box>
      )}
    </>
  );
};

export default PlayerResults;